var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.currentComponent,{ref:"modalComponent",tag:"component",attrs:{"token":_vm.token,"customerID":_vm.customer_id,"booked_event_link":_vm.booked_event_link},on:{"login":_vm.login}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }